shadow$provide[309] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Stereographic4:{enumerable:true, get:function() {
  return Stereographic4;
}}});
var UAxis = require("../../../util/axis.js");
var require$_DOT__SLASH_view_DOT_js = require("./view.js");
class Stereographic4 extends require$_DOT__SLASH_view_DOT_js.View {
  static initClass() {
    this.traits = ["node", "object", "visible", "view", "view4", "stereographic", "vertex",];
  }
  make() {
    super.make();
    this.uniforms = {basisOffset:this._attributes.make(this._types.vec4()), basisScale:this._attributes.make(this._types.vec4()), stereoBend:this.node.attributes["stereographic.bend"],};
    this.basisScale = this.uniforms.basisScale.value;
    this.basisOffset = this.uniforms.basisOffset.value;
  }
  unmake() {
    super.unmake();
    delete this.basisScale;
    delete this.basisOffset;
    delete this.uniforms;
  }
  change(changed, touched, init) {
    let bend;
    if (!touched["view"] && !touched["view4"] && !touched["stereographic"] && !init) {
      return;
    }
    this.bend = bend = this.props.bend;
    const p = this.props.position;
    const s = this.props.scale;
    const g = this.props.range;
    const {x} = g[0];
    const y = g[1].x;
    const z = g[2].x;
    let w = g[3].x;
    const dx = g[0].y - x || 1;
    const dy = g[1].y - y || 1;
    const dz = g[2].y - z || 1;
    let dw = g[3].y - w || 1;
    const mult = function(a, b) {
      a.x *= b.x;
      a.y *= b.y;
      a.z *= b.z;
      a.w *= b.w;
    };
    [w, dw] = Array.from(UAxis.recenterAxis(w, dw, bend, 1));
    this.basisScale.set(2 / dx, 2 / dy, 2 / dz, 2 / dw);
    this.basisOffset.set(-(2 * x + dx) / dx, -(2 * y + dy) / dy, -(2 * z + dz) / dz, -(2 * w + dw) / dw);
    mult(this.basisScale, s);
    mult(this.basisOffset, s);
    this.basisOffset.add(p);
    if (changed["view.range"] || touched["stereographic"]) {
      this.trigger({type:"view.range",});
    }
  }
  vertex(shader, pass) {
    if (pass === 1) {
      shader.pipe("stereographic4.position", this.uniforms);
    }
    return super.vertex(shader, pass);
  }
}
Stereographic4.initClass();

};